import { Language } from './language.interfaces';

class LanguagePersistance {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- a constant, not an injected member
  private static readonly LANGUAGE_LS_KEY = 'APP_LANGUAGE';

  public getLanguage() {
    const localStorageLanguage = localStorage.getItem(
      LanguagePersistance.LANGUAGE_LS_KEY,
    ) as Language;

    if (Language[localStorageLanguage]) {
      return Language[localStorageLanguage];
    } else {
      return undefined;
    }
  }

  public setLanguage(language: Language) {
    localStorage.setItem(LanguagePersistance.LANGUAGE_LS_KEY, language);
  }
}

export const languagePersistance = new LanguagePersistance();

function getDefaultLanguage() {
  const navigatorLanguage = navigator.language.slice(0, 2);

  return (
    (Object.keys(Language).find(lang => navigatorLanguage === lang) as Language) ??
    Language.en
  );
}

export function loadLanguage() {
  const persistedLanguage = languagePersistance.getLanguage();

  if (persistedLanguage) {
    return persistedLanguage;
  }

  return getDefaultLanguage();
}
